import type { TrackerComponentProps } from 'OpalChat/Tracker';
import React from 'react';

/**
 * Host-side lazy loader for the federated Tracker search icon
 * (`OpalChat/TrackerSearch`). Renders as a magnifying-glass button that
 * toggles the inline search input row inside the sibling-mounted `Tracker`.
 * See `LazyTracker` for the parallel-fetch rationale.
 */
const OpalChatTrackerSearchPromise: Promise<{
  default: React.ComponentType<TrackerComponentProps>;
}> = import('OpalChat/TrackerSearch')
  .then(m => ({ default: m.TrackerSearchComponent }))
  .catch((error: unknown) => {
    console.error('Failed to load OpalChat TrackerSearch:', error);
    return { default: () => null };
  });

export const LazyTrackerSearch = React.lazy(() => OpalChatTrackerSearchPromise);
